import {  Button, Dialog,  DialogContent, DialogActions, DialogTitle, Box, IconButton, Typography } from '@mui/material';
import { Printer } from '../../../assets';
import { useTranslation } from 'react-i18next';
import { theme } from '../../../theme';
import CloseIcon from '@mui/icons-material/Close';

export interface PrintStockCount  {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}
const PrintStockCountModal=( props: PrintStockCount) => {
  const { t } = useTranslation('stockCount');

  return (
    
    <Dialog
      open={props.open}
      onClose={props.onClose}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
        <Printer/>
        <Typography variant="textLG"
          sx={{ ml: '5px' }}>
          {t('printTitle')}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={props.onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: () => theme.palette.custom.gray[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent>
        {
          <Typography variant="textSM"
            sx={{ color: () => theme.palette.custom.gray[600] }}>
            {t('printWarning')}
          </Typography>
        }
      </DialogContent>
      <DialogActions>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Button
            variant="secondary"
            onClick={props.onClose}>
            {t('cancel')}
          </Button>
          <Button
            variant="primary"
            onClick={props.onConfirm}
            sx={{ ml: '12px' }}>
            {t('print')}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default PrintStockCountModal;